import { CALCULATIONS_CONFIG, CalculationConfig, CalculationType } from '@/core';
import { OptionsEditorControl } from '../OptionsEditorLayout';
import { SettingsAutocomplete } from '../SettingsAutocomplete';

type AutocompleteCalculationOption = CalculationConfig & { id: CalculationType };
const CALC_OPTIONS: AutocompleteCalculationOption[] = Object.entries(CALCULATIONS_CONFIG).map(([id, config]) => {
  return {
    id: id as CalculationType,
    ...config,
  };
});

export interface CalculationSelectorProps {
  value: CalculationType;
  onChange: (unit: CalculationType) => void;
}

export function CalculationSelector({ value, onChange }: CalculationSelectorProps) {
  const handleCalculationChange = (_: unknown, newValue: AutocompleteCalculationOption) => {
    onChange(newValue.id);
  };

  const calcConfig = CALCULATIONS_CONFIG[value];

  return (
    <OptionsEditorControl
      label="Calculation"
      control={
        <SettingsAutocomplete
          value={{
            ...calcConfig,
            id: value,
          }}
          options={CALC_OPTIONS}
          onChange={handleCalculationChange}
          disableClearable
        ></SettingsAutocomplete>
      }
    />
  );
}
